import { Declaration } from 'store/declarations/declaration';
import { DeclarationExternalEntity } from './declaration-external-entity';

export enum DeclarationCountry {
    IRELAND = 'ireland',
    UK = 'uk',
    EU = 'eu',
}

export const declarationCountryDisplay: Record<DeclarationCountry, string> = {
    [DeclarationCountry.IRELAND]: 'Ireland',
    [DeclarationCountry.UK]: 'UK',
    [DeclarationCountry.EU]: 'EU',
};

export const declarationExternalEntityCountryMap: Record<DeclarationExternalEntity, DeclarationCountry> = {
    [DeclarationExternalEntity.REVENUE]: DeclarationCountry.IRELAND,
    [DeclarationExternalEntity.HMRC]: DeclarationCountry.UK,
    [DeclarationExternalEntity.CDS]: DeclarationCountry.UK,
    [DeclarationExternalEntity.CHIEF]: DeclarationCountry.UK,
    [DeclarationExternalEntity.GVMS]: DeclarationCountry.UK,
    [DeclarationExternalEntity.ICS2]: DeclarationCountry.EU,
};

export const declarationCountryLabels = [
    { id: DeclarationCountry.IRELAND, value: 'ireland' },
    { id: DeclarationCountry.UK, value: 'uk' },
    { id: DeclarationCountry.EU, value: 'eu' },
] as const;

export const getDeclrationCountry = (declaration: Declaration): DeclarationCountry => {
    if (declaration.declarationExternalEntity === DeclarationExternalEntity.REVENUE) {
        return DeclarationCountry.IRELAND;
    } else if (declaration.declarationExternalEntity === DeclarationExternalEntity.ICS2) {
        return DeclarationCountry.EU;
    } else {
        return DeclarationCountry.UK;
    }
};
